export function stripBodylessJsonContentType(
  _path: string,
  options: RequestInit,
) {
  if (!shouldStripContentType(options)) {
    return;
  }

  const nextHeaders = new Headers(options.headers);
  nextHeaders.delete('content-type');

  return {
    ...options,
    headers: nextHeaders,
  };
}

function shouldStripContentType(options: RequestInit) {
  if (options.body !== undefined && options.body !== null) {
    return false;
  }

  const method = readMethod(options);

  switch (method) {
    case 'DELETE':
    case 'GET':
    case 'HEAD':
    case 'OPTIONS':
      return new Headers(options.headers).has('content-type');
    default:
      return false;
  }
}

function readMethod(options: RequestInit) {
  return options.method?.toUpperCase() ?? 'GET';
}
